import { ISearchElementStyle } from './searchPageConfig';

// Consumer-side mirror of the admin editor's cart page config
// (ac-main/web: components/Storefront/Editor/cartPageConfig.ts). Persisted as a single JSON
// string on IStorefrontSettings.cartPageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the cart page via elementStyleFrom. Absent config = zero
// inline styles (the page renders exactly as before), so this is strictly additive.
export interface ICartPageConfig {
    // The page's main content wrapper (max-width column).
    container?: ISearchElementStyle;
    // The "Cart" page heading.
    title?: ISearchElementStyle;
    // A product line-item row (desktop table row + mobile card share this).
    itemRow?: ISearchElementStyle;
    // A bundle line-item row.
    bundleRow?: ISearchElementStyle;
    // The per-line quantity stepper input (desktop table + mobile card share this). Background and
    // border-color are applied via CSS vars so they survive the theme's blanket .fui-Input re-skin.
    quantityInput?: ISearchElementStyle;
    // The container that wraps all the line-item rows (frames the desktop table and mobile list).
    rowsContainer?: ISearchElementStyle;
    // The cart summary / subtotal box.
    summaryBox?: ISearchElementStyle;
    // The "Cart Summary" heading inside the summary box.
    summaryHeading?: ISearchElementStyle;
    // The primary "Checkout" call-to-action button.
    checkoutButton?: ISearchElementStyle;
    // The secondary cart buttons (Request a Quote, Add More, Share, …).
    secondaryButton?: ISearchElementStyle;
    // The empty-cart state (icon + message + Go Home).
    emptyState?: ISearchElementStyle;
    // The "Go Home" button inside the empty-cart state (defaults to Fluent primary blue).
    emptyStateButton?: ISearchElementStyle;
    // Behavior flag (not a style section): when true, the header cart icon opens the cart in a
    // right-side slide-out panel instead of navigating to the full /cart page.
    openInPanel?: boolean;
}

export const CART_PAGE_SECTIONS = [
    'container', 'title', 'itemRow', 'bundleRow', 'quantityInput', 'rowsContainer', 'summaryBox',
    'summaryHeading', 'checkoutButton', 'secondaryButton', 'emptyState', 'emptyStateButton',
] as const;

export const DEFAULT_CART_PAGE_CONFIG: ICartPageConfig = {};

export function parseCartPageConfig(raw?: string): ICartPageConfig {
    if (!raw) return { ...DEFAULT_CART_PAGE_CONFIG };
    try {
        return { ...DEFAULT_CART_PAGE_CONFIG, ...(JSON.parse(raw) as ICartPageConfig) };
    } catch {
        return { ...DEFAULT_CART_PAGE_CONFIG };
    }
}
